import { instance } from '../instance'

/**
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getCountryList = async () => {
  return instance.get('/v1/country', {
    skipAuth: true,
  })
}
